export default __webpack_public_path__ + "static/media/383.00ddf52b.png";